/**
 * Builds the assignee query params for the Open Items list filter.
 *
 * The Open Items table stores both shapes on the model (spackle-api
 * `ProjectOpenItem`):
 *
 *   - assignee_id    : bigint, FK to users (a registered user)
 *   - assignee_label : string, free-text label (denormalised from the
 *                      assignee's user label, but still meaningful when no
 *                      user is linked)
 *
 * A filter that only matches `assignee_id` silently hides every free-text
 * assignment, which is the failure mode this utility exists to avoid.
 *
 * Encoding of the FilterHeader value:
 *
 *   'all'             -> no filter
 *   'user:<id>'       -> filter by assignee_id  = <id>  (registered user)
 *   'label:<text>'    -> filter by assignee_label = <text>  (free-text)
 *
 * The prefix is fixed-length so a label that itself begins with `user:` or
 * `label:` does not collide with the user form, as long as callers always
 * wrap a label in `label:` and never send a raw label string.
 */
export class AssigneeFilterUtil {
  static getAssigneeParams(filterValue) {
    if (!filterValue || filterValue === 'all') {
      return null;
    }
    if (filterValue.startsWith('user:')) {
      const id = filterValue.slice('user:'.length);
      if (id === '') return null;
      return { assignee_id: id };
    }
    if (filterValue.startsWith('label:')) {
      const text = filterValue.slice('label:'.length);
      if (text === '') return null;
      return { assignee_label: text };
    }
    return null;
  }
}
